import { ControlPropertyType } from '../../../enums';

export const DatePickerProperty = {
  ...ControlPropertyType,
  MinDate: 'minDate',
  MaxDate: 'maxDate',
  DisabledWeekdays: 'disabledWeekdays',
  DisabledDateRange: 'disabledDateRange',
  FillType: 'fillType',
  Holidays: 'holidays',
};

export default {
  DatePickerProperty,
};
